import { IconProps } from '../../icon';

export function VtTitledIcon(props: IconProps) {
  return (
    <svg
      width="40"
      height="56"
      viewBox="0 0 40 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.04662 34.915L6.01214 15.053C6.28845 13.9477 7.28151 13.1724 8.42076 13.1724H31.8542C32.9934 13.1724 33.9865 13.9477 34.2628 15.053L39.2283 34.915C39.62 36.482 38.4349 38 36.8197 38H3.45525C1.84004 38 0.654874 36.482 1.04662 34.915Z"
        fill="#212121"
        stroke="#212121"
        strokeWidth="1.24138"
      />
      <path
        d="M20.7579 19.3793H9.58553M13.3097 18.1379V22.4828M13.3097 22.4828L17.4068 24.0192C17.9218 24.2123 18.2483 24.7213 18.2091 25.27L17.6545 33.0345M13.3097 22.4828H8.96484M10.8269 32.4138L11.8523 27.7997C11.9785 27.2317 12.4823 26.8276 13.0641 26.8276H22.9667C23.501 26.8276 23.9754 27.1695 24.1443 27.6764L24.8198 29.7029C24.9888 30.2098 25.4632 30.5517 25.9975 30.5517H33.7924"
        stroke="white"
        strokeWidth="1.24138"
      />
      <path
        d="M23.6255 8.74451C24.015 9.15346 24.5465 9.38621 25.1042 9.38621C25.38 9.38621 25.6527 9.32915 25.9066 9.21871C26.1605 9.1083 26.3901 8.9469 26.5829 8.74451C26.7756 8.54214 26.9278 8.30272 27.0313 8.04026C27.1348 7.77783 27.1879 7.49703 27.1879 7.21379C27.1879 6.64239 26.9719 6.09152 26.5829 5.68308C26.1934 5.27413 25.6619 5.04138 25.1042 5.04138C24.5465 5.04138 24.015 5.27413 23.6255 5.68308C23.2365 6.09152 23.0204 6.64239 23.0204 7.21379C23.0204 7.7852 23.2365 8.33607 23.6255 8.74451ZM25.1042 16.4116C24.9718 16.2497 24.7898 16.023 24.5739 15.7437C24.1122 15.1464 23.4971 14.3102 22.8825 13.3538C22.2674 12.3965 21.6564 11.3243 21.2 10.2546C20.742 9.18113 20.449 8.13157 20.449 7.21379C20.449 5.90856 20.943 4.65966 21.8178 3.74112C22.6921 2.82309 23.8746 2.31034 25.1042 2.31034C26.3338 2.31034 27.5163 2.82309 28.3906 3.74112C29.2654 4.65966 29.7594 5.90856 29.7594 7.21379C29.7594 8.13157 29.4664 9.18113 29.0084 10.2546C28.552 11.3243 27.941 12.3965 27.3259 13.3538C26.7113 14.3102 26.0962 15.1464 25.6345 15.7437C25.4186 16.023 25.2366 16.2497 25.1042 16.4116Z"
        fill="#212121"
        stroke="white"
        strokeWidth="0.62069"
      />
      <ellipse
        cx="25.1039"
        cy="19.3793"
        rx="2.48276"
        ry="1.24138"
        fill="white"
      />
      <path
        d="M16.875 53.4346L18.3545 48H20.2734L17.876 55.1094H16.6357L16.875 53.4346ZM15.5322 48L17.0117 53.4346L17.2607 55.1094H16.0059L13.623 48H15.5322Z"
        fill="#212121"
      />
      <path
        d="M24.2383 48V55.1094H22.5244V48H24.2383ZM26.377 48V49.3232H20.4346V48H26.377Z"
        fill="#212121"
      />
    </svg>
  );
}

export default VtTitledIcon;
